<div
  class="announce-price-thesis-edit-container"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <mat-form-field appearance="outline">
    <mat-label>قمیت سفارش:</mat-label>
    <input [formControl]="priceFormControl" type="text" matInput />
    <span matSuffix>
      {{ priceFormControl.value | irc : "T" | digitsEnToFa }}
    </span>
  </mat-form-field>

  <button
    (click)="closeWithPrice()"
    [disabled]="!this.priceFormControl.valid"
    mat-stroked-button
  >
    ثبت قیمت <jam-icon name="check"></jam-icon>
  </button>
</div>
